module.exports = __webpack_public_path__ + "img/scroll.eb34954f.gif";